const data = [
    {
        "id": 1,
        "name": "Spread positive energy with Gold!",
        "dec":"Develop your distinct flair and express your vitality; the community will notice and honor your contributions!",
        "img": "https://ninetheme.com/themes/goldsmith/wp-content/uploads/2022/12/background-10.webp",
        "btn":"Make Order",
        "position": "start-position" ,
        "speed":1
    }
];

export default data;